import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.referrerUrl = document.referrer
    this.element.addEventListener("click", this.handleBackClick.bind(this))
  }

  handleBackClick(event) {
    event.preventDefault()
    this.safeBackNavigation()
  }

  safeBackNavigation() {
    if (window.history.length > 1) {
      window.history.back()
    } else if (this.referrerUrl && this.isSameDomain(this.referrerUrl)) {
      Turbo.visit(this.referrerUrl)
    } else {
      const fallbackUrl = this.element.dataset.fallbackUrl
      Turbo.visit(fallbackUrl)
    }
  }

  isSameDomain(url) {
    try {
      const referrerDomain = new URL(url).hostname
      const currentDomain = window.location.hostname
      return referrerDomain === currentDomain
    } catch {
      return false
    }
  }
}